import * as React from 'react';
import { cn } from 'utils/utils';
import { PageHeaderWithFiltersContext } from './context';
import { Checkboxes } from './checkboxes';
import { FiltersToggleButton } from './filters-toggle-button';
import type { CheckboxesConfig } from './types';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  checkboxesConfig?: CheckboxesConfig;
};

export const PageHeaderWithFilters = ({
  children,
  className,
  checkboxesConfig,
  ...props
}: Props) => {
  const [open, setOpen] = React.useState(false);
  const [selectedCheckboxValues, setSelectedCheckboxValues] = React.useState<
    string[]
  >(checkboxesConfig?.defaultSelected ?? []);

  const resetSelectedCheckboxValues = React.useCallback(() => {
    setSelectedCheckboxValues(checkboxesConfig?.defaultSelected ?? []);
  }, [checkboxesConfig?.defaultSelected]);

  return (
    <PageHeaderWithFiltersContext.Provider
      value={{
        open,
        setOpen,
        checkboxesConfig: checkboxesConfig ?? { options: [] },
        selectedCheckboxValues,
        setSelectedCheckboxValues,
        resetSelectedCheckboxValues,
      }}
    >
      <div
        className={cn(
          'flex flex-col w-full rounded-md bg-white px-6 py-4 shadow-sm shadow-slate-300',
          className
        )}
        {...props}
      >
        <div className={'flex flex-row items-center'}>
          <Checkboxes />
          <FiltersToggleButton className={'ml-auto'} />
        </div>
        <div
          className={cn(
            'border-t-slate-300 border-t pt-3 mt-4 hidden',
            open && 'flex'
          )}
        >
          {children}
        </div>
      </div>
    </PageHeaderWithFiltersContext.Provider>
  );
};
